module.exports = __webpack_public_path__ + "static/media/discover_active.833ae367.svg";